import { ORDER_STATUS } from "./constants";

export default {
  colors: {
    blue: "#1F79E2",
    darkBlue: "#0153cc",
    lightBlue: "#cadefb",
    lighterBlue: "#e6effc",
    black: "#001737",
    grey: "#545454",
    darkGrey: "#42526E",
    stelBlue: "#1b6ede",
  },
  fontSize: {
    small: "13px",
    medium: "14px",
    large: "15px",
    xlarge: "16px",
    xxlarge: "17px",
  },
};

export const orderStatusStyles = () => ({
  [ORDER_STATUS.PROCESSED]: {
    border: "1px solid #1876d1",
    color: "#1876d1",
  },
  [ORDER_STATUS.CANCELLED]: {
    border: "1px solid #eb0013",
    color: "#eb0013",
  },
  [ORDER_STATUS.COMPLETE]: {
    border: "1px solid #66bb69",
    color: "#66bb69",
  },
  [ORDER_STATUS.CONFIRMED]: {
    border: "1px solid #2979ff",
    color: "#2979ff",
  },
  [ORDER_STATUS.SHIPPED]: {
    border: "1px solid #ff5722",
    color: "#ff5722",
  },
  [ORDER_STATUS.PENDING_CONFIRM.replace(" ", "_")]: {
    border: "1px solid #ff9800",
    color: "#ff9800",
  },
  [ORDER_STATUS.AWAITING_PO.replace(" ", "_")]: {
    border: "1px solid #a323bc",
    color: "#a323bc",
  },
});
